import React, { useEffect, useState, useMemo, useRef } from "react";
import { Link } from "react-router-dom";
// import { Media } from "react-bootstrap";
// import DataTable from "react-data-table-component";
// import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { loader_image } from "../_components/Imagepath";
import { IconButton, Tooltip, MenuItem } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { formatDistanceToNow } from 'date-fns';
import { base_url, Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from 'material-react-table';
import Select from "react-select";
// import $ from "jquery";
import PropTypes from 'prop-types';

import Swal from 'sweetalert2';

const RawMaterialPricing = () => {
  const [menu, setMenu] = useState(false);
  //const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);

  // Refs for top scrollbar
  const topScrollRef = useRef(null);
  const tableContainerRef = useRef(null);
  const [datasupplier, setDatasupplier] = useState([]);
  const [supplierName, setSupplierName] = useState([]);
  const [permission, setPermission] = useState({});
  const [overviewpricing, setOverviewpricing] = useState({});
  const [overviewaveragepricing, setOverviewaveragepricing] = useState({});
  const [sumblnet, setSumblnet] = useState(0);


  const [formData, setFormData] = useState({
    supplier: '',
    start_date: '',
    end_date: ''
  });




  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0, // 0-based index for React Table
    pageSize: 10, // Default rows per page
  });

  // Fetch Data using React Query
  const {
    data: queryData,
    isError,
    isRefetching,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [
      "api/raw-materials/listing2",
      pagination.pageIndex,
      pagination.pageSize,
      columnFilters,
      globalFilter,
      sorting,
    ],
    queryFn: async () => {
      try {
        console.log("Fetching with pagination:", {
          page: pagination.pageIndex + 1,
          pageSize: pagination.pageSize,
        });

        const response = await axios.post(
          `${base_url}/raw-materials/listing2`,
          {
            filters: columnFilters,
            search: globalFilter,
            page: pagination.pageIndex + 1, // API expects 1-based indexing
            pageSize: pagination.pageSize,
            // sorting: sorting.map(({ id, desc }) => ({
            //   column: id,
            //   order: desc ? "desc" : "asc",
            // })),
            sorting: sorting.map(({ id, desc }) => ({
              column: id,
              order: desc ? "desc" : "asc",
            })),
          },
          {
            headers: {
              Authorization: `Bearer ${Authtoken}`,
              Apitoken: Apitoken,
            },
          }
        );

        console.log("API Response:", response.data);

        if (response.data.code === 200) {
          return {
            data: Array.isArray(response.data.data?.supply_chain_headers)
              ? response.data.data.supply_chain_headers
              : [],
            meta: {
              totalRowCount: response.data.data?.totalRowCount || 0,
              pageCount: Math.ceil((response.data.data?.totalRowCount || 0) / pagination.pageSize)
            },
          };
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        return {
          data: [],
          meta: {
            totalRowCount: 0,
            pageCount: 0
          }
        };
      }
    },
    placeholderData: keepPreviousData,
  });

  const tableData = queryData?.data || [];
  const totalRowCount = queryData?.meta?.totalRowCount || 0;
  const pageCount = queryData?.meta?.pageCount || 0;

  useEffect(() => {
    console.log("Table Data:", tableData);
    console.log("Current Pagination:", pagination);
    console.log("Total Pages:", pageCount);
    console.log("Total Rows:", totalRowCount);
  }, [tableData, pagination, pageCount, totalRowCount]);

  // const permission = useYourPermissionHook(); // Replace with your actual permission hook
  useEffect(() => {
    setPermission(FindModuleById(191));
    console.log(permission);
  });

  // const CustomLotNumberCell = ({ row }) => {
  //   if (!row || !row.original) return null; // Prevents errors if row is undefined
  //   return permission && permission.update === 1 ? (
  //     <a className="btn btn-link" href={`/raw-material-pricing-edit/${row.original.id}`}>
  //       {row.original.lot_number}
  //     </a>
  //   ) : (
  //     <span>{row.original.lot_number}</span>
  //   );
  // };\
  const CustomLotNumberCell = ({ row }) => {
    if (!row || !row.original) return null;
    return permission && permission.update === 1 ? (
      <a className="btn btn-link" href={`/raw-material-pricing-edit/${row.original.id}`}>
        {row.original.lot_number || 'N/A'}
      </a>
    ) : (
      <span>{row.original.lot_number || 'N/A'}</span>
    );
  };

  CustomLotNumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        lot_number: PropTypes.string,
      }),
    }),
  };



  // Define table columns
  const columns = useMemo(
    () => [

      {
        header: "Lot Number",
        accessorFn: (row) => `${row.lot_number}`,
        Cell: CustomLotNumberCell,
      },
      {
        header: "Supplier",
        accessorFn: (row) => `${row.supplier_name ? row.supplier_name.name : ""}`,
      },
      {
        header: "Location",
        accessorFn: (row) =>
          `${row.location_name ? row.location_name.title : ""}`,
      },
      {
        accessorKey: 'product_name',
        header: 'Product',
      },
      {
        accessorKey: 'note',
        header: 'Note',
      },
      {
        header: "Grade A Price",
        accessorFn: (row) =>
          parseFloat(row.grade_a_price).toFixed(2) +
          `${row.raw_currency ? row.raw_currency.symbol : ""}`,
      },

      //      {
      //   header: 'Grade A Net Weight',
      //   accessorFn: (row) => {
      //     const netWeight = row.grade_a_net_weight ?? 0; // Default to 0 if undefined or null
      //     return `${Number(netWeight).toFixed(2)} (KG)`;
      //   },
      // },
      {
        header: 'Grade A Net Weight',
        accessorFn: (row) => {
          let grade_a_net_weight = 0;
          if (row.id > 357) {
            grade_a_net_weight = row.grade_a_bl_weight;
          } else {
            grade_a_net_weight = row.grade_a_net_weight;
          }
          const netWeight = grade_a_net_weight ?? 0; // Default to 0 if undefined or null
          return `${Number(netWeight).toFixed(2)} (KG)`;
        },
      },
      {
        header: "Grade B Price",
        accessorFn: (row) =>
          parseFloat(row.grade_b_price).toFixed(2) +
          `${row.raw_currency ? row.raw_currency.symbol : ""}`,
      },
      //    {
      //   header: 'Grade B Net Weight',
      //   accessorFn: (row) => {
      //     const netWeight = row.grade_b_net_weight ?? 0; // Default to 0 if undefined or null
      //     return `${Number(netWeight).toFixed(2)} (KG)`;
      //   },
      // },
      {
        header: 'Grade B Net Weight',
        accessorFn: (row) => {
          let grade_b_net_weight = 0;
          if (row.id > 357) {
            grade_b_net_weight = row.grade_b_bl_weight;
          } else {
            grade_b_net_weight = row.grade_b_net_weight;
          }

          const netWeight = grade_b_net_weight ?? 0; // Default to 0 if undefined or null
          return `${Number(netWeight).toFixed(2)} (KG)`;
        },
      },

      {
        header: 'Amount',
        accessorFn: (row) => {
          const netWeight = row.total_amount ?? 0; // Default to 0 if undefined or null
          return `${Number(netWeight).toFixed(2)} (MAD)`;
        },
      },

      {
        header: 'Net Weight',
        accessorFn: (row) => {
          const netWeight = row.total_net_weight ?? 0; // Default to 0 if undefined or null
          return `${Number(netWeight).toFixed(2)} (KG)`;
        },
      },


      // {
      //   header: "BL Net Weight",
      //   accessorFn: (row) => `${row.net_weight.toFixed(2)} (KG)`,
      // },

      // {
      //   header: "BL Gross Weight",
      //   accessorFn: (row) => `${row.gross_weight.toFixed(2)} (KG)`,
      // },
      {
        accessorKey: "driver_name",
        header: "Driver Name",
      },
      {
        accessorKey: "plate_number",
        header: "Plate Number",
      },

      {
        accessorKey: "shift_date",
        header: "Shift Date",
      },
      {
        header: "Farm",
        accessorFn: (row) => `${row.farmer_detail ? row.farmer_detail.name : ""}`,
      },


      {
        accessorKey: "date_time",
        header: "Date Time",
      },

      {
        header: "Created By",
        accessorFn: (row) =>
          `${row.createdby ? row.createdby.first_name + " " + row.createdby.last_name : ""}`,
      },
      {
        header: 'Created At',
        accessorFn: (row) =>
          formatDistanceToNow(new Date(row.created_at), { addSuffix: true }),
      },
      {
        header: "Updated By",
        accessorFn: (row) =>
          `${row.updatedby ? row.updatedby.first_name + " " + row.updatedby.last_name : ""}`,
      },
      {
        header: 'Updated At',
        accessorFn: (row) =>
          formatDistanceToNow(new Date(row.updated_at), { addSuffix: true }),
      },
    ],
    [permission]
  );

  useEffect(() => {

    axios.post("/suppliers-trader/listing", {}, {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken,
      },
    }
    ).then((response) => {
      if (response.data.code === 200) {
        let suppliers = response.data.data.suppliers;
        let supplierslist = suppliers.map((cat, index) => ({
          label: cat.name,
          value: cat.id,
          key: `categories-${index}`,
        }));
        setSupplierName(supplierslist);
      } else {
        console.log("API response is not an array");
      }
    }).catch((error) => {
      console.log(error);
    });
    axios
      .post(
        "/raw-materials/listing",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        //setData(response.data.data.materials);
        setDataa(response.data.data.materials_groupby);
        setDatasupplier(response.data.data.materials_supplier);

        let all_material = response.data.data.materials;
        const sum_bl_net = all_material.reduce((sum, material) => {
          const material_weight = material.id > 357
            ? (material.grade_a_bl_weight + material.grade_b_bl_weight)
            : material.net_weight;
          return sum + material_weight;
        }, 0);
        setSumblnet(sum_bl_net);

    const total_net_weight = all_material.reduce((sum, item) => sum + item.total_net_weight, 0);
        setSumblnet(total_net_weight);
        console.log(sum_bl_net);

      })
      .catch((error) => {
        console.log(error);
      });



    axios
      .post(
        "/raw-materials/listing-pricing-overview",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        // setData(response.data.data.materials_overview);

        setOverviewaveragepricing(response.data.data.average_prices);
        setOverviewpricing(response.data.data.materials_overview);


        // setSumTotalWeight(response.data.data.materials_overview.sum_total_net_weight);
      })
      .catch((error) => {
        console.log(error);
      });





  }, []);

  const viewItem = (item) => {
    window.location.href = "/raw-material-pricing-view/" + item;
  }
  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/raw-materials/delete/${item}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
          .then((response) => {
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                window.location.href = "/raw-materials";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  // const columns = [

  // ];


  const ShiftDateCell = ({ row }) => {
    if (!row || !row.original) return null;
    return (
      <a
        href={`/raw-material-pricing-groupby/${row.original.shift_date}_${row.original.location}`}
        className=""
      >
        {row.original.shift_date}
      </a>
    );
  };

  ShiftDateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string,
        location: PropTypes.string,
      }),
    }),
  };

  const LocationCell = ({ row }) => {
    if (!row || !row.original) return null;
    return (
      <span>
        {row.original.location_name ? row.original.location_name.title : ""}
      </span>
    );
  };

  LocationCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        location_name: PropTypes.shape({
          title: PropTypes.string,
        }),
      }),
    }),
  };


  const AverageBuyingPriceCell = ({ row }) => {

    let a_grade_avg_price = 0;
    if (row.original.shift_date > '2025-12-30') {

      a_grade_avg_price = Number(row.original.avg_a_grade_price_bl || 0).toFixed(2);
    } else {

      a_grade_avg_price = Number(row.original.a_grade_avg_price || 0).toFixed(2);

    }

    return a_grade_avg_price;
  };

  AverageBuyingPriceCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        total_price_a: PropTypes.number,
        sum_grade_a_net_weight: PropTypes.number,
        sum_grade_a_price: PropTypes.number,
        total_raw: PropTypes.number,
      }),
    }),
  };


  const AverageBuyingPriceCellB = ({ row }) => {

    const cutoffDate = new Date('2025-12-30');
    const shiftDate = new Date(row.original.shift_date);

    let b_grade_avg_price = 0;

    if (shiftDate > cutoffDate) {
      b_grade_avg_price = Number(row.original.avg_b_grade_price_bl ?? 0).toFixed(2);
    } else {
      b_grade_avg_price = Number(row.original.b_grade_avg_price ?? 0).toFixed(2);
    }

    return b_grade_avg_price;
  };

  AverageBuyingPriceCellB.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        total_price_b: PropTypes.number,
        sum_grade_b_net_weight: PropTypes.number,
        sum_grade_b_price: PropTypes.number,
        total_raw: PropTypes.number,
      }),
    }),
  };






  const columnss = [
    {
      header: "Shift Date",
      accessorFn: (row) => `${row.shift_date}`,
      Cell: ShiftDateCell,
    },
    {
      header: "Location",
      accessorFn: (row) => `${row.location_name ? row.location_name.title : ""}`,
      Cell: LocationCell,
    },
    {
      header: "Net Weight",
      accessorFn: (row) => `${row.sum_net_weight.toFixed(2)} (KG)`,
    },
    {
      header: "Grade A Average Buying Price",
      accessorFn: (row) => {


        const cutoffDate = new Date('2025-12-30');
        const shiftDate = new Date(row.shift_date);

        let a_grade_avg_price = 0;

        if (shiftDate > cutoffDate) {
          a_grade_avg_price = Number(row.avg_a_grade_price_bl ?? 0).toFixed(2);

        } else {
          a_grade_avg_price = Number(row.a_grade_avg_price ?? 0).toFixed(2);
        }

        return a_grade_avg_price;
      },
      Cell: AverageBuyingPriceCell,
    },
    {
      header: "Grade B Average Buying Price",
      accessorFn: (row) => {

        // const block = row.total_price_b || 0;
        // const weight = row.sum_grade_b_net_weight || 0;
        // let b_grade_avg_price = 0;
        // if(row.id > 357){
        // const totalRaw = Number(row.total_raw || 0);
        // const sumPrice = Number(row.sum_grade_b_price || 0);

        // b_grade_avg_price = totalRaw > 0 ? `${(sumPrice / totalRaw).toFixed(2)}dh`: "0dh";
        // }else{
        // b_grade_avg_price =   weight === 0 ? "0dh" : `${(block / weight).toFixed(2)}dh`;

        // }
        const cutoffDate = new Date('2025-12-30');
        const shiftDate = new Date(row.shift_date);

        let b_grade_avg_price = 0;

        if (shiftDate > cutoffDate) {
          b_grade_avg_price = Number(row.avg_b_grade_price_bl ?? 0).toFixed(2);
        } else {
          b_grade_avg_price = Number(row.b_grade_avg_price ?? 0).toFixed(2);
        }

        return b_grade_avg_price;
      },
      Cell: AverageBuyingPriceCellB,
    },


    {
      header: "No of Receptions",
      accessorFn: (row) => `${row.total_raw}`,
    },
  ];



  const SupplierCell = ({ row }) => {
    if (!row || !row.original) return null;
    return (
      <a
        href={`/raw-material-pricing-supplier-groupby/${row.original.supplier}`}
        className=""
      >
        {row.original.supplier_name ? row.original.supplier_name.name : ""}
      </a>
    );
  };

  SupplierCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        supplier: PropTypes.string,
        supplier_name: PropTypes.shape({
          name: PropTypes.string,
        }),
      }),
    }),
  };

  const AverageBuyingPriceA = ({ row }) => {

    let a_avg = 0;
    if (row.original.a_grade_avg_price > 0 && row.original.avg_a_grade_price_bl > 0) {
      a_avg = (row.original.a_grade_avg_price + row.original.avg_a_grade_price_bl) / 2;
    } else if (row.original.a_grade_avg_price > 0 && row.original.avg_a_grade_price_bl < 1) {
      a_avg = row.original.a_grade_avg_price;  // ✅ Fixed: should use a_grade_avg_price
    } else if (row.original.avg_a_grade_price_bl > 0 && row.original.a_grade_avg_price < 1) {
      a_avg = row.original.avg_a_grade_price_bl;  // ✅ This one was correct
    }

    return `${a_avg.toFixed(2)}dh`;
  };

  AverageBuyingPriceA.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        a_grade_avg_price: PropTypes.number,
        avg_a_grade_price_bl: PropTypes.number,

      }),
    }),
  };
  const AverageBuyingPriceB = ({ row }) => {
    let b_avg = 0;

    if (row.original.b_grade_avg_price > 0 && row.original.avg_b_grade_price_bl > 0) {
      b_avg = (row.original.b_grade_avg_price + row.original.avg_b_grade_price_bl) / 2;
    } else if (row.original.b_grade_avg_price > 0 && row.original.avg_b_grade_price_bl < 1) {
      b_avg = row.original.b_grade_avg_price;  // ✅ Fixed: should use a_grade_avg_price
    } else if (row.original.avg_b_grade_price_bl > 0 && row.original.b_grade_avg_price < 1) {
      b_avg = row.original.avg_b_grade_price_bl;  // ✅ This one was correct
    }

    return `${b_avg.toFixed(2)}dh`;
  };

  AverageBuyingPriceB.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        avg_b_grade_price_bl: PropTypes.number,
        b_grade_avg_price: PropTypes.number,
      }),
    }),
  };



  const columnssupplier = [
    {
      header: "Supplier",
      accessorFn: (row) => `${row.supplier_name ? row.supplier_name.name : ""}`,
      Cell: SupplierCell,
    },
    {
      header: "Location",
      accessorFn: (row) => `${row.location_name ? row.location_name.title : ""}`,
    },
    {
      header: "Net Weight",
      accessorFn: (row) => `${row.sum_net_weight.toFixed(2)} (KG)`,
    },
    {
      header: "Grade A Average Buying Price",
      accessorFn: (row) => {
        let a_avg = 0;

        if (row.a_grade_avg_price > 0 && row.avg_a_grade_price_bl > 0) {
          a_avg = (row.a_grade_avg_price + row.avg_a_grade_price_bl) / 2;
        } else if (row.a_grade_avg_price > 0 && row.avg_a_grade_price_bl < 1) {
          a_avg = row.a_grade_avg_price;  // ✅ Fixed: should use a_grade_avg_price
        } else if (row.avg_a_grade_price_bl > 0 && row.a_grade_avg_price < 1) {
          a_avg = row.avg_a_grade_price_bl;  // ✅ This one was correct
        }

        return `${a_avg.toFixed(2)}dh`;

      },
      Cell: AverageBuyingPriceA,
    },
    {
      header: "Grade B Average Buying Price",
      accessorFn: (row) => {
        let b_avg = 0;

        if (row.b_grade_avg_price > 0 && row.avg_b_grade_price_bl > 0) {
          b_avg = (row.b_grade_avg_price + row.avg_b_grade_price_bl) / 2;
        } else if (row.b_grade_avg_price > 0 && row.avg_b_grade_price_bl < 1) {
          b_avg = row.b_grade_avg_price;  // ✅ Fixed: should use a_grade_avg_price
        } else if (row.avg_b_grade_price_bl > 0 && row.b_grade_avg_price < 1) {
          b_avg = row.avg_b_grade_price_bl;  // ✅ This one was correct
        }

        return `${b_avg.toFixed(2)}dh`;
      },
      Cell: AverageBuyingPriceB,
    },
    {
      header: "Receptions",
      accessorFn: (row) => `${row.total_raw}`,
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post("/raw-materials/listing", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {


        if (response.data.code === 200) {

          //  setData(response.data.data.materials);
          setDataa(response.data.data.materials_groupby);
          setDatasupplier(response.data.data.materials_supplier);

          let all_material = response.data.data.materials;
          const sum_bl_net = all_material.reduce((sum, material) => {
            const material_weight = material.id > 357
              ? (material.grade_a_bl_weight + material.grade_b_bl_weight)
              : material.net_weight;
            return sum + material_weight;
          }, 0);
          setSumblnet(sum_bl_net);
        }
        else {
          //setBackendErrors(response.data.error);
        }
      })
      .catch((error) => {
        console.log(error)
        // actions.setSubmitting(false);
      });

  }
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    console.log(Input_name)
    // delete backendErrors[Input_name];
  };


  function objectToQueryString(obj) {
    return Object.keys(obj)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
      .join('&');
  }
  const downloadExcel = (e) => {
    console.log(e);
    const queryString = objectToQueryString(formData);
    window.open(`${base_url}/raw-material-pricing/list-excel?${queryString}`, '_blank');

  }


  const handleSelectChangeCustomer = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, supplier: selectedOption.value });
  };


  useEffect(() => {
    const syncScrollbars = () => {
      const tableContainer = document.querySelector('.production-output-listing .MuiTableContainer-root');
      const topScroll = topScrollRef.current;
      const topScrollContent = topScroll?.querySelector('.top-scroll-content');

      if (tableContainer && topScroll && topScrollContent) {
        topScrollContent.style.width = `${tableContainer.scrollWidth}px`;

        const handleTopScroll = () => {
          tableContainer.scrollLeft = topScroll.scrollLeft;
        };

        const handleTableScroll = () => {
          topScroll.scrollLeft = tableContainer.scrollLeft;
        };

        topScroll.addEventListener('scroll', handleTopScroll);
        tableContainer.addEventListener('scroll', handleTableScroll);

        return () => {
          topScroll.removeEventListener('scroll', handleTopScroll);
          tableContainer.removeEventListener('scroll', handleTableScroll);
        };
      }
    };

    const timer = setTimeout(syncScrollbars, 100);
    return () => clearTimeout(timer);
  }, [tableData]);


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Raw Material Pricing</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">Raw Material Pricing Listing</li>
                  </ul>
                </div>
                <div className="col-auto">

                  {permission && permission.list === 1 && (

                    <button
                      className="btn btn-primary"
                      onClick={() => downloadExcel()}
                    >
                      <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image} />
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div id="filter_inputs" className="card filter-card">
              <div className="card-body pb-0">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Select Supplier:</label>
                        <Select
                          options={supplierName}
                          name="supplier"
                          value={supplierName.find(option => option.value === formData.supplier) || null} // Ensure it selects the correct option
                          onChange={(selectedOption) => handleSelectChangeCustomer(selectedOption)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Start Date:</label>
                        <input type="date" name="start_date" className="form-control" value={formData.start_date} onChange={(e) => {
                          handleChange(e);
                          customHandleInput(e);
                        }} />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>End Date:</label>
                        <input type="date" name="end_date" className="form-control" value={formData.end_date} onChange={(e) => {
                          handleChange(e);
                          customHandleInput(e);
                        }} />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="pt-4 mt-2">
                        <button type="submit" className="btn btn-primary">
                          Filter
                        </button>
                        &nbsp;&nbsp;
                        <a href="/raw-material-pricing" className="btn btn-primary me-1"><i className="fa fa-times"></i></a>

                      </div>
                    </div>
                  </div>
                </form>

              </div>
            </div>
            <div className="row">

              <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                <div className="card inovices-card w-100">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <div className="dash-count text-center">
                        <div className="dash-title"> Total Weight</div>
                        <div className="dash-counts">
                          <p>{(Number(sumblnet) || 0).toFixed(2)} KG</p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                <div className="card inovices-card w-100">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <div className="dash-count text-center">
                        <div className="dash-title">Grade A Average Buying</div>
                        <div className="dash-counts">
                          <p>
                            {overviewaveragepricing.avg_a_grade
                              ? (overviewaveragepricing.avg_a_grade)
                              : '0.000'}
                          </p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                <div className="card inovices-card w-100">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <div className="dash-count text-center">
                        <div className="dash-title">Grade B Average Buying</div>
                        <div className="dash-counts">
                          <p>
                            {overviewaveragepricing.avg_b_grade
                              ? (overviewaveragepricing.avg_b_grade)
                              : '0.000'}
                          </p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                <div className="card inovices-card w-100">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <div className="dash-count text-center">
                        <div className="dash-title"> Total Reception </div>
                        <div className="dash-counts">
                          <p>{overviewpricing.total_raw}</p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>

            <div className="row">
              <div className="col-sm-12">

                <section className="comp-section">
                  <div className="row">
                    <div className="col-md-12">
                      {permission && permission.list === 1 && (
                        <div className="card bg-white">

                          <div className="card-body">
                            <ul className="nav nav-tabs nav-tabs-bottom">

                              <li className="nav-item">
                                <a className="nav-link " href="#listing-groupby" data-bs-toggle="tab">Raw material by Shift Date  and Location</a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link" href="#listing-groupby-supplier" data-bs-toggle="tab">Raw material by Supplier</a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link active" href="#listing-all" data-bs-toggle="tab"> Raw Material Pricing</a>
                              </li>
                            </ul>
                            <div className="tab-content">
                              <div className="tab-pane " id="listing-groupby">
                                <div className="row" id="listing-followup-groupby" >
                                  <div className="col-sm-12" >
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive ">

                                          <MaterialReactTable columns={columnss} data={dataa}
                                            enableColumnOrdering
                                            enablePinning
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="tab-pane " id="listing-groupby-supplier">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">

                                          <MaterialReactTable columns={columnssupplier} data={datasupplier}
                                            enableColumnOrdering
                                            enablePinning
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                              <div className="tab-pane  show active" id="listing-all">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">

                                        <div
                                          ref={topScrollRef}
                                          className="top-scrollbar"
                                          style={{
                                            overflowX: 'auto',
                                            overflowY: 'hidden',
                                            marginBottom: '10px',
                                            height: '20px'
                                          }}
                                        >
                                          <div className="top-scroll-content" style={{ height: '1px' }}></div>
                                        </div>


                                        <div className="table-responsive production-output-listing" ref={tableContainerRef}>
                                          <MaterialReactTable columns={columns}
                                            data={tableData}
                                            manualFiltering
                                            manualPagination
                                            manualSorting
                                            muiToolbarAlertBannerProps={
                                              isError
                                                ? { color: "error", children: "Error loading data" }
                                                : undefined
                                            }
                                            onColumnFiltersChange={setColumnFilters}
                                            onGlobalFilterChange={setGlobalFilter}
                                            onSortingChange={setSorting}
                                            onPaginationChange={setPagination}
                                            renderTopToolbarCustomActions={() => (
                                              <Tooltip arrow title="Refresh Data">
                                                <IconButton onClick={() => refetch()}>
                                                  <RefreshIcon />
                                                </IconButton>
                                              </Tooltip>
                                            )}
                                            rowCount={totalRowCount}
                                            pageCount={pageCount}
                                            enableDebug={true}
                                            state={{
                                              columnFilters,
                                              globalFilter,
                                              isLoading,
                                              pagination,
                                              showAlertBanner: isError,
                                              showProgressBars: isRefetching,
                                              sorting,
                                            }}

                                            enablePinning
                                            enableRowActions
                                            renderRowActionMenuItems={({ row }) => [
                                              permission?.list === 1 && (
                                                <MenuItem key="edit" onClick={() => viewItem(row.original.id)}>
                                                  View
                                                </MenuItem>
                                              ),
                                              permission?.delete === 1 && (
                                                <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                  Delete
                                                </MenuItem>
                                              ),
                                            ]}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>

                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default RawMaterialPricing;
